import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from '@ortho-next/auth-core';
import { AppVersionGuard } from './app-version.guard';
import { ErrorComponent, FallbackComponent } from './core';
import { PrintBomComponent, PrintOrPlanComponent } from './print';
import { ContainerTemplateComponent } from './template';
import { ViewComponent } from './view';


export const routes: Routes = [
	{ path: 'error', component: ErrorComponent },
	{
		path: '', component: ContainerTemplateComponent, canActivate: [AuthGuardWithForcedLogin, AppVersionGuard]
	},
	{
		path: 'view', component: ViewComponent, canActivate: [AuthGuardWithForcedLogin]
	},
	{ path: 'or-plan', outlet: 'print', component: PrintOrPlanComponent, canActivate: [AuthGuardWithForcedLogin, AppVersionGuard] },
	{ path: 'bom', outlet: 'print', component: PrintBomComponent, canActivate: [AuthGuardWithForcedLogin, AppVersionGuard] },
	{ path: '**', component: FallbackComponent, canActivate: [AuthGuardWithForcedLogin] }
];